import { createLogger, format, transports } from 'winston'
import config from '../config'

const logger = createLogger({
  level: 'info',
  exitOnError: false,
  format: format.json(),
  transports: [new transports.Console({ level: 'info' })],
  defaultMeta: { env: config.env }
})

export default config.env === 'local' ? console : logger
